import { Modal } from '@hopskipdrive/react-components';

import { Button } from '../Button';

export type UnsavedChangesModalProps = {
  open: boolean;
  onDiscard: () => void;
  onKeepEditing: () => void;
};

export const UnsavedChangesModal = ({ open, onDiscard, onKeepEditing }: UnsavedChangesModalProps) => (
  <Modal open={open}>
    <Modal.Title>Unsaved changes</Modal.Title>
    <Modal.Content>You have unsaved changes. If you leave now, they will be lost.</Modal.Content>
    <Modal.Actions>
      <Button color="secondary" onClick={onDiscard} data-testid="unsaved-changes-discard">
        Discard Changes
      </Button>
      <Button color="primary" onClick={onKeepEditing} data-testid="unsaved-changes-keep-editing">
        Keep Editing
      </Button>
    </Modal.Actions>
  </Modal>
);
